import {ORGANIZATION_HOST, ORGANIZATION_INSTANCE,ACCOUNT_HOST, ACCOUNTS_INSTANCE, RECORDING_HOST, RECORDING_INSTANCE,} from "@/helper/consts";
import {checkUrlAllowedWithParameters, getUrlAllowed, getUrlWithParameters, makeMediaHostUrl} from "@/helper/urls";


export default {
    getAccountsUrlWithParameters: function (name, method, parameters, gets) {
        return getUrlWithParameters(
            ACCOUNT_HOST, ACCOUNTS_INSTANCE, name, method, parameters, gets
        );
    },
    getRecordingUrlWithParameters: function (name, method, parameters, gets) {
        return getUrlWithParameters(
            RECORDING_HOST, RECORDING_INSTANCE, name, method, parameters, gets
        );
    },
    getWorkerUrlWithParameters: function (name, method, parameters, gets) {
        return getUrlWithParameters(
            ORGANIZATION_HOST, ORGANIZATION_INSTANCE, name, method, parameters, gets
        );
    },
    getRecordingUrlAllowed(name, method) {
        return getUrlAllowed(RECORDING_INSTANCE, name, method)
    },
}
